{
  "familyId": "SPR-KLANK-JAGER",
  "questions": [
    {
      "id": "SPR-KLANK-JAGER-001",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Verdeel het woord 'jager' in lettergrepen. Welke verdeling is juist?",
      "options": ["ja-ger", "jag-er", "ja-gerr", "jaa-ger"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "jager", "syllables": ["ja", "ger"], "types": ["open", "closed"], "label": "Lettergreepverdeling: ja-ger" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel (open lettergreep)", "content": "Bij 'jager' eindigt de eerste lettergreep op een klinker: ja-ger. De 'a' klinkt lang omdat de lettergreep open is (eindigt op een klinker). Je schrijft maar één 'a'.", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_jager",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Jager' verdeel je als ja-ger. De eerste lettergreep 'ja' eindigt op een klinker — dat is een open lettergreep. In een open lettergreep klinkt de klinker lang, en schrijf je maar één letter.",
        "solutionSteps": [
          "Verdeel in lettergrepen: ja-ger",
          "De eerste lettergreep 'ja' eindigt op een klinker → open lettergreep",
          "Open lettergreep → lange klank → één klinker schrijven"
        ],
        "distractorExplanations": {
          "0": "Goed! 'ja-ger' — de eerste lettergreep is open (eindigt op een klinker), dus de 'a' klinkt lang.",
          "1": "Je dacht waarschijnlijk dat de 'g' bij de eerste lettergreep hoort. Maar dan wordt het 'jag-er' en klinkt de 'a' kort (zoals in 'jacht'). Bij 'jager' klinkt de 'a' lang → ja-ger. Onthoud: open lettergreep = lange klank.",
          "2": "Je dacht waarschijnlijk dat je twee r's schrijft. Maar 'jager' heeft maar één 'r'. De dubbele medeklinker hoort bij de bakker-regel (korte klinker), niet bij de jager-regel (lange klinker). Onthoud: lange klank = enkele medeklinker.",
          "3": "Je dacht waarschijnlijk dat je twee a's schrijft. Maar in een open lettergreep (ja-ger) schrijf je maar één 'a' — de klank is al lang door de open lettergreep. Onthoud: open lettergreep = één klinker."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.closed-syllable-split", "label": "Medeklinker bij eerste lettergreep getrokken", "optionIndex": 1 },
          { "id": "spr.double-consonant-for-long", "label": "Dubbele medeklinker bij lange klank", "optionIndex": 2 },
          { "id": "spr.vowel-doubled-in-open-syllable", "label": "Dubbele klinker in open lettergreep", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-JAGER-002",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Welke spelling van het werkwoord is juist?",
      "options": ["loppen", "loopen", "lopen", "lopn"],
      "correctAnswer": 2,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "lopen", "syllables": ["lo", "pen"], "types": ["open", "closed"], "label": "Lettergreepverdeling: lo-pen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel: lopen", "content": "Verdeel: lo-pen. De eerste lettergreep 'lo' is open (eindigt op een klinker). De 'o' klinkt lang → schrijf één 'o' en één 'p'.", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_lopen",
      "variantIndex": 2,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Lopen' verdeel je als lo-pen. De eerste lettergreep 'lo' is open — de 'o' klinkt lang. Bij een open lettergreep schrijf je maar één klinker en één medeklinker.",
        "solutionSteps": [
          "Verdeel in lettergrepen: lo-pen",
          "'lo' eindigt op een klinker → open lettergreep",
          "Lange klank → één 'o' en één 'p'"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je twee p's schrijft. Maar 'loppen' zou een korte 'o' geven (zoals in 'hoppen'). Bij 'lopen' klinkt de 'o' lang → één 'p'. Onthoud: lange klank = enkele medeklinker (jager-regel).",
          "1": "Je dacht waarschijnlijk dat je twee o's schrijft. Maar in een open lettergreep (lo-pen) is de klank al lang — je hoeft geen extra 'o' toe te voegen. Onthoud: open lettergreep = één klinker.",
          "2": "Goed! 'lopen' — open lettergreep, dus één 'o' en één 'p'.",
          "3": "Je dacht waarschijnlijk dat je de 'e' weglaat. Maar 'lopn' is geen bestaand woord. Het is 'lo-pen' met twee lettergrepen. Onthoud: elk woord heeft minstens één klinker per lettergreep."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.double-consonant-for-long", "label": "Dubbele medeklinker bij lange klank", "optionIndex": 0 },
          { "id": "spr.vowel-doubled-in-open-syllable", "label": "Dubbele klinker in open lettergreep", "optionIndex": 1 },
          { "id": "spr.missing-syllable", "label": "Lettergreep weggelaten", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-JAGER-003",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Het woord 'boten' (meervoud van boot). Welke lettergreepverdeling hoort erbij?",
      "options": ["bot-en", "bo-ten", "boo-ten", "bo-tten"],
      "correctAnswer": 1,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "boten", "syllables": ["bo", "ten"], "types": ["open", "closed"], "label": "Lettergreepverdeling: bo-ten" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel: boten", "content": "Verdeel: bo-ten. De eerste lettergreep 'bo' is open. De 'o' klinkt lang → schrijf één 'o'. Vergelijk met 'botten' (korte 'o', dubbele 't' — bakker-regel).", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_boten",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Boten' verdeel je als bo-ten. De eerste lettergreep 'bo' is open — de 'o' klinkt lang. Vergelijk: 'botten' (korte 'o', dubbele 't') is de bakker-regel.",
        "solutionSteps": [
          "Luister: klinkt de 'o' lang of kort?",
          "Lang → open lettergreep → bo-ten",
          "Kort zou zijn: bot-ten (bakker-regel)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de 't' bij de eerste lettergreep hoort. Maar dan wordt het 'bot-en' en klinkt de 'o' kort (zoals in 'botten'). Bij 'boten' klinkt de 'o' lang → bo-ten. Onthoud: lange klank = open lettergreep.",
          "1": "Goed! 'bo-ten' — open lettergreep, lange 'o'.",
          "2": "Je dacht waarschijnlijk dat je twee o's schrijft. Maar in een open lettergreep (bo-ten) is de klank al lang — je hoeft geen extra 'o' toe te voegen. Onthoud: open lettergreep = één klinker.",
          "3": "Je dacht waarschijnlijk dat je twee t's schrijft. Maar 'bo-tten' bestaat niet. Dubbele medeklinker hoort bij een korte klinker (bakker-regel). Bij 'boten' is de 'o' lang → één 't'. Onthoud: lange klank = enkele medeklinker."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.closed-syllable-split", "label": "Medeklinker bij eerste lettergreep (bot-en)", "optionIndex": 0 },
          { "id": "spr.vowel-doubled-in-open-syllable", "label": "Dubbele klinker in open lettergreep", "optionIndex": 2 },
          { "id": "spr.double-consonant-for-long", "label": "Dubbele medeklinker bij lange klank", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-JAGER-004",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Het regent buiten. Welke spelling van 'regen' is juist?",
      "options": ["reggen", "reegen", "regn", "regen"],
      "correctAnswer": 3,
      "stimulusAids": [
        { "type": "syllableBlocks", "data": { "word": "regen", "syllables": ["re", "gen"], "types": ["open", "closed"], "label": "Lettergreepverdeling: re-gen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel: regen", "content": "Verdeel: re-gen. De eerste lettergreep 're' is open (eindigt op een klinker). De 'e' klinkt lang → schrijf één 'e' en één 'g'.", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_regen",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Regen' verdeel je als re-gen. De eerste lettergreep 're' is open — de 'e' klinkt lang. Bij een open lettergreep schrijf je maar één klinker en één medeklinker.",
        "solutionSteps": [
          "Verdeel in lettergrepen: re-gen",
          "'re' eindigt op een klinker → open lettergreep",
          "Lange klank → één 'e' en één 'g'"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je twee g's schrijft. Maar 'reggen' zou een korte 'e' geven (zoals in 'leggen'). Bij 'regen' klinkt de 'e' lang → één 'g'. Onthoud: lange klank = enkele medeklinker.",
          "1": "Je dacht waarschijnlijk dat je twee e's schrijft. Maar in een open lettergreep (re-gen) is de klank al lang. Onthoud: open lettergreep = één klinker.",
          "2": "Je dacht waarschijnlijk dat je de 'e' weglaat. Maar 'regn' is geen bestaand woord. Het is 're-gen' met twee lettergrepen. Onthoud: elke lettergreep heeft een klinker.",
          "3": "Goed! 'regen' — open lettergreep, dus één 'e' en één 'g'."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.double-consonant-for-long", "label": "Dubbele medeklinker bij lange klank", "optionIndex": 0 },
          { "id": "spr.vowel-doubled-in-open-syllable", "label": "Dubbele klinker in open lettergreep", "optionIndex": 1 },
          { "id": "spr.missing-syllable", "label": "Lettergreep weggelaten", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-JAGER-005",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Welk woord past bij de jager-regel (open lettergreep, lange klank)?",
      "options": ["weven", "bakker", "rennen", "zitten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel herkennen", "content": "De jager-regel: open lettergreep → lange klank → enkele medeklinker. 'we-ven' heeft een open eerste lettergreep ('we'). De andere woorden hebben een gesloten eerste lettergreep met korte klinker (bakker-regel).", "icon": "lightbulb" } },
        { "type": "syllableBlocks", "showWhen": "wrong", "data": { "word": "weven", "syllables": ["we", "ven"], "types": ["open", "closed"], "label": "Lettergreepverdeling: we-ven — open eerste lettergreep" } }
      ],
      "conceptId": "open_syllable_recognition",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Weven' past bij de jager-regel. Verdeel: we-ven. De eerste lettergreep 'we' is open — de 'e' klinkt lang. De andere woorden (bakker, rennen, zitten) hebben een gesloten eerste lettergreep met korte klinker → bakker-regel.",
        "solutionSteps": [
          "Verdeel elk woord: we-ven, bak-ker, ren-nen, zit-ten",
          "'we-ven': open lettergreep → jager-regel ✓",
          "De andere drie: gesloten lettergreep → bakker-regel"
        ],
        "distractorExplanations": {
          "0": "Goed! 'we-ven' heeft een open eerste lettergreep → jager-regel.",
          "1": "Je dacht waarschijnlijk dat 'bakker' bij de jager-regel hoort. Maar 'bak-ker' heeft een gesloten eerste lettergreep met korte 'a' → bakker-regel (dubbele medeklinker). Onthoud: korte klank = bakker-regel.",
          "2": "Je dacht waarschijnlijk dat 'rennen' bij de jager-regel hoort. Maar 'ren-nen' heeft een gesloten eerste lettergreep met korte 'e' → bakker-regel. Onthoud: dubbele medeklinker = korte klank = bakker-regel.",
          "3": "Je dacht waarschijnlijk dat 'zitten' bij de jager-regel hoort. Maar 'zit-ten' heeft een gesloten eerste lettergreep met korte 'i' → bakker-regel. Onthoud: dubbele medeklinker = korte klank = bakker-regel."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.bakker-jager-verward", "label": "Bakker-regel verward met jager-regel", "optionIndex": 1 },
          { "id": "spr.bakker-jager-verward", "label": "Bakker-regel verward met jager-regel", "optionIndex": 2 },
          { "id": "spr.bakker-jager-verward", "label": "Bakker-regel verward met jager-regel", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-JAGER-009",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "categorize",
      "question": "Sorteer de woorden bij de juiste regel.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Jager-regel (lange klank)", "Bakker-regel (korte klank)"],
        "items": [
          { "text": "bomen", "correctCategory": 0 },
          { "text": "bommen", "correctCategory": 1 },
          { "text": "slapen", "correctCategory": 0 },
          { "text": "slappen", "correctCategory": 1 },
          { "text": "muren", "correctCategory": 0 },
          { "text": "mussen", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "syllableBlocks", "showWhen": "wrong", "data": { "word": "bomen", "syllables": ["bo", "men"], "types": ["open", "closed"], "label": "bo-men: open lettergreep → jager-regel" } },
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager- vs. bakker-regel", "content": "Jager-regel: open lettergreep → lange klank → één medeklinker (bo-men, sla-pen, mu-ren). Bakker-regel: gesloten lettergreep → korte klank → dubbele medeklinker (bom-men, slap-pen, mus-sen).", "icon": "lightbulb" } }
      ],
      "conceptId": "jager_bakker_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De jager-regel geldt bij een open lettergreep (eindigt op een klinker): bo-men, sla-pen, mu-ren → lange klank, één medeklinker. De bakker-regel geldt bij een gesloten lettergreep (eindigt op een medeklinker): bom-men, slap-pen, mus-sen → korte klank, dubbele medeklinker.",
        "solutionSteps": [
          "Verdeel elk woord in lettergrepen",
          "Eindigt de eerste lettergreep op een klinker? → open → jager-regel (1 medeklinker)",
          "Eindigt de eerste lettergreep op een medeklinker? → gesloten → bakker-regel (2 medeklinkers)",
          "Jager: bo-men, sla-pen, mu-ren. Bakker: bom-men, slap-pen, mus-sen"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-JAGER-011",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "error_spotting",
      "question": "Zoek de spelfouten in deze tekst.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De jaager liep door het bos. Hij zag hazen rennen over het velt.",
        "errors": [
          {
            "word": "jaager",
            "position": 1,
            "correction": "jager",
            "explanation": "Ja-ger: open lettergreep → één 'a' (jager-regel)."
          },
          {
            "word": "velt",
            "position": 12,
            "correction": "veld",
            "explanation": "Veld eindigt op 'd' (meervoud: velden — je hoort de 'd')."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel", "content": "In een open lettergreep schrijf je de lange klank met één letter: ja-ger (niet jaager). De open lettergreep maakt de klank al lang.", "icon": "lightbulb" } }
      ],
      "conceptId": "jager_error_spotting",
      "variantIndex": 11,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Twee fouten: 'jaager' moet 'jager' zijn — ja-ger heeft een open lettergreep, dus schrijf je één 'a' (jager-regel). 'Velt' moet 'veld' zijn — velden, je hoort de 'd'.",
        "solutionSteps": [
          "Fout 1: jaager → jager (open lettergreep → één klinker, jager-regel)",
          "Fout 2: velt → veld (velden → d)",
          "Correct: bos, hazen, rennen ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-JAGER-012",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over de jager-regel waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "In een open lettergreep klinkt de klinker lang.", "isTrue": true },
          { "text": "'Jager' schrijf je met twee a's: jaager.", "isTrue": false },
          { "text": "Bij 'lo-pen' is de eerste lettergreep open.", "isTrue": true },
          { "text": "In een open lettergreep verdubbel je de medeklinker.", "isTrue": false },
          { "text": "'Regen' verdeel je als re-gen (open lettergreep).", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De jager-regel", "content": "In een open lettergreep (eindigt op een klinker) klinkt de klinker lang. Je schrijft maar één klinker en één medeklinker: ja-ger (niet jaager), lo-pen (niet loppen), re-gen (niet reggen).", "icon": "lightbulb" } }
      ],
      "conceptId": "jager_regel_tf_series",
      "variantIndex": 12,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De jager-regel: open lettergreep → lange klank → één klinker, één medeklinker. Dus 'jager' (niet jaager), 'lo-pen' heeft een open eerste lettergreep, en 're-gen' ook. Je verdubbelt de medeklinker NIET bij een open lettergreep — dat is de bakker-regel (korte klank).",
        "solutionSteps": [
          "Stelling 1: Waar ✓ — open lettergreep = lange klank",
          "Stelling 2: Onwaar ✗ — jager heeft één a (ja-ger, open)",
          "Stelling 3: Waar ✓ — lo-pen: 'lo' eindigt op klinker = open",
          "Stelling 4: Onwaar ✗ — verdubbelen = bakker-regel (korte klank)",
          "Stelling 5: Waar ✓ — re-gen: 're' eindigt op klinker = open"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-JAGER-013",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste lettergreepverdeling.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "jager", "right": "ja-ger" },
          { "left": "lopen", "right": "lo-pen" },
          { "left": "boten", "right": "bo-ten" },
          { "left": "regen", "right": "re-gen" },
          { "left": "weven", "right": "we-ven" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Lettergrepen bij de jager-regel", "content": "Bij de jager-regel eindigt de eerste lettergreep op een klinker (open): ja-ger, lo-pen, bo-ten, re-gen, we-ven. De medeklinker gaat naar de tweede lettergreep.", "icon": "lightbulb" } }
      ],
      "conceptId": "jager_regel_matching",
      "variantIndex": 13,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bij de jager-regel gaat de medeklinker naar de tweede lettergreep, zodat de eerste lettergreep open is (eindigt op een klinker): ja-ger, lo-pen, bo-ten, re-gen, we-ven.",
        "solutionSteps": [
          "De medeklinker gaat naar de tweede lettergreep",
          "Eerste lettergreep eindigt op een klinker (open)",
          "ja-ger, lo-pen, bo-ten, re-gen, we-ven"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-JAGER-014",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'boom'. Typ het hele woord.",
      "options": [],
      "correctAnswer": "bomen",
      "data": {
        "acceptedAnswers": ["bomen"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "syllableBlocks", "showWhen": "wrong", "data": { "word": "bomen", "syllables": ["bo", "men"], "types": ["open", "closed"], "label": "bo·men — open lettergreep, één 'o'" } },
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel bij meervoud", "content": "'Boom' heeft een lange 'o'. In het meervoud krijg je een open lettergreep: bo-men. Schrijf één 'o' en één 'm' (jager-regel).", "icon": "lightbulb" } }
      ],
      "conceptId": "jager_regel_fill_bomen",
      "variantIndex": 14,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Boom' wordt in het meervoud 'bomen'. Verdeel: bo-men. De eerste lettergreep 'bo' is open (eindigt op een klinker), dus de 'o' klinkt al lang — schrijf maar één 'o'. Dit is de jager-regel.",
        "solutionSteps": [
          "'Boom' → meervoud: bomen",
          "Verdeel: bo-men (open lettergreep)",
          "Open lettergreep → één klinker, één medeklinker (jager-regel)"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-KLANK-JAGER-015",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een spelfout?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "De aapen klimmen in de boom.", "hasError": true, "correction": "De apen klimmen in de boom.", "explanation": "A-pen: open lettergreep → één 'a' (jager-regel). 'Aapen' is fout." },
          { "text": "We lopen naar het park.", "hasError": false, "explanation": "'Lopen' is correct: lo-pen, open lettergreep → één 'o'." },
          { "text": "De regen valt al uren.", "hasError": false, "explanation": "'Regen' is correct: re-gen, open lettergreep → één 'e'." },
          { "text": "Zij weven een kleed.", "hasError": false, "explanation": "'Weven' is correct: we-ven, open lettergreep → één 'e'." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Jager-regel: beoordelen", "content": "In een open lettergreep schrijf je maar één klinker. 'Apen' wordt verdeeld als a-pen (open lettergreep). Dus schrijf je één 'a', niet 'aa'. Dit is de jager-regel.", "icon": "lightbulb" } }
      ],
      "conceptId": "jager_regel_sentence_judge",
      "variantIndex": 15,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Aapen' is fout. Het woord 'apen' verdeel je als a-pen. De eerste lettergreep is open (eindigt op een klinker), dus de klank is al lang — schrijf maar één 'a'. Dit is de jager-regel: open lettergreep → één klinker.",
        "solutionSteps": [
          "Verdeel: a-pen (open lettergreep)",
          "Open lettergreep → lange klank → één klinker (jager-regel)",
          "Dus: apen (niet aapen)",
          "Lopen, regen, weven zijn correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}